<template>
  <jc-dialog ref="dialog" :show.sync="show"
             btn-confirm-text='<i class="far fa-trash-alt"></i> Xóa'
             title="Xác nhận xóa"
             type="red"
             @onConfirm="submit()"
  >
    <div style="overflow: hidden">
      <c-form ref="form" @submit="submit()">
        <c-input v-model="model.productId" label="ID sản phẩm" readonly/>
        <c-input v-model="model.productName" label="Tên sản phẩm" readonly/>
        <c-input v-model="model.sku" label="SKU" readonly/>
        <c-input v-model="model.warehouseName" label="Tên kho" readonly/>
        <b-row>
          <b-col>
            <c-input v-model="model.totalAvailable"
                     label="Tồn có thể bán"
                     readonly=""
            />
          </b-col>
          <b-col>
            <c-input v-model="model.totalFreeze"
                     label="Tồn chờ xuất"
                     readonly=""
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <c-input v-model="model.totalIn"
                     label="Tổng nhập"
                     readonly=""
            />
          </b-col>
          <b-col>
            <c-input v-model="model.totalOut"
                     label="Tổng xuất"
                     readonly=""
            />
          </b-col>
        </b-row>
      </c-form>
    </div>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "ConfirmDeleteProductDetail",
  mixins: [
    dialogMixins
  ],
  data() {
    return {
      model: {
        productDetailId: null,
        productId: null,
        productName: null,
        sku: null,
        warehouseName: null,
        totalAvailable: null,
        totalFreeze: null,
        totalIn: null,
        totalOut: null,
        shopOrder: null,
      }
    }
  },
  methods: {
    open(item) {
      this.show = true;
      this.model.productDetailId = item.productDetailId;
      this.model.productId = item.productId;
      this.model.productName = item.productName;
      this.model.sku = item.sku;
      this.model.warehouseName = item.warehouseName;
      this.model.totalAvailable = item.totalAvailable;
      this.model.totalFreeze = item.totalFreeze;
      this.model.totalIn = item.totalIn;
      this.model.totalOut = item.totalOut;
      this.model.shopOrder = item.shopOrder;
    },
    submit() {
      this.$showLoader();
      this.$http
          .delete(`/package-service/v1.0/backdoor/product-detail/${this.model.productDetailId}`,
              {
                headers: {
                  "shop_order" : this.model.shopOrder,
                  "shop_type" : 0,
                }
              })
          .then(successRes => {
            this.close();
            this.$success();
            this.$stopLoader();

            this.$emit("success", successRes);
          })
          .catch(reason => {
            this.$stopLoader();
            this.errorNotify(reason)
                .then(err => {
                  this.$error(err.response.data.message);
                })
            this.$emit("error", reason);
          })
    }
  }
}
</script>

<style scoped>

</style>